<template>
  <v-menu
    bottom
    left
    nudge-bottom="40"
    transition="scroll-y-transition"
    :close-on-content-click="false"
    v-model="showMenu"
  >
    <template v-slot:activator="{ on }">
      <v-btn
          :class="{ 'primary-font-color': isTransparent }"
          :color="isTransparent ? '' : 'primary'"
          icon light v-on="on" @click="getAwardedGrowthVitaminCards">
        <v-badge :content="getQuantity" :value="getQuantity" color="secondary">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" >
                shopping_cart
              </v-icon>
            </template>
            <span>{{ $translate('SHOPPINGCART') }}</span>
          </v-tooltip>
        </v-badge>
      </v-btn>
    </template>
    <v-card class="pa-0">
      <v-card-subtitle>
  <v-row justify="space-between">
    <div  class="mx-3 my-3" >{{ $translate('SHOPPINGCART') }}</div>
    <v-btn
      justify="end"
      small
      depressed
      color="red accent-3"
      class="text-capitalize white--text mx-3 my-2"
      @click="EmptyShoppingCart"
    >
      {{ $translate('EMPTY_CART') }}
    </v-btn>
  </v-row>
</v-card-subtitle>
      <v-divider light />
      <v-col class="pa-0" v-if="shoppingCart.length !== 0">
        <v-list class="pb-0" dense>
          <v-card elevation="0" class="scrollSection">
            <template v-for="(order, orderIndex) in shoppingCart">
              <!-- Shopping cart item for Tickets -->
              <v-list-item
                :key="orderIndex"
                v-if="order.ShoppingCartType === 'Ticket'"
                class="px-3"
              >
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-avatar>
                    <v-img :src="order.Picture" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="order.Name" />
                    <v-list-item-subtitle
                      v-for="(
                        priceCategory, priceCategoryIndex
                      ) in order.PriceCategories"
                      :key="
                        'priceCategoryIndex' +
                        priceCategoryIndex +
                        'index' +
                        orderIndex
                      "
                    >
                      {{ priceCategory.PriceCategoryName }}
                      ({{ priceCategory.Quantity }} *
                      {{
                        formatter.format(getPriceCategoryPrice(priceCategory))
                      }})
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-row class="ma-0" align="end">
                      <v-col class="pa-0 pl-2" align="end">
                        <h3>
                          {{ formatter.format(getOrderTotalPrice(order)) }}
                        </h3>
                      </v-col>
                      <v-btn
                        icon
                        color="red accent-3"
                        small
                        class="my-auto ml-3"
                        @click="removeOrderFromShoppingCart(order, orderIndex)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-row>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <!-- Shopping cart item for Products and Rentals -->
              <template
                v-else
                v-for="(product, productIndex) in order.Products"
              >
                <v-list-item
                  :key="'productIndex' + productIndex + 'index' + orderIndex"
                  class="px-3"
                >
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-avatar size="35">
                      <v-img :src="product.PictureUrl"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <!-- Product name -->
                      <v-list-item-title v-text="product.ProductName" />

                      <!-- Product aspects -->
                      <v-list-item-subtitle
                        v-if="
                          product.Aspects != null &&
                          product.Aspects.trim() !== ''
                        "
                      >
                        {{ product.Aspects }}
                      </v-list-item-subtitle>

                      <!-- Product options -->
                      <v-list-item-subtitle
                        v-if="
                          product.OrderProductOptionsSummary != null &&
                          product.OrderProductOptionsSummary.trim() !== ''
                        "
                      >
                        {{ product.OrderProductOptionsSummary }}
                      </v-list-item-subtitle>
                      <v-row
                        class="ma-0"
                        v-if="
                          product.Product != null &&
                          product.Product.AvailabilityBatchGroup != null &&
                          product.Product.AvailabilityBatchGroup.BatchGroupId !=
                            0
                        "
                      >
                        <ProductAvailabilityInfo></ProductAvailabilityInfo>
                      </v-row>
                    </v-list-item-content>

                    <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                      <ShoppingListProductActions
                        :product="product"
                        :totalPrice="getProductTotalPrice(product)"
                        :quantity="
                          getDisplayQuantity(product, product.Quantity)
                        "
                        :isWeighted="product.ProductType === 'Weighted'"
                        :unit="getDisplayUnit(product)"
                        :decreaseBtnDisabled="isDecreaseBtnDisabled(product)"
                        :increaseBtnDisabled="isIncreaseBtnDisabled(product)"
                        @decrease="
                          onAddOrSubtractsProduct(
                            'subtracts',
                            product,
                            order,
                            orderIndex
                          )
                        "
                        @increase="
                          onAddOrSubtractsProduct(
                            'add',
                            product,
                            order,
                            orderIndex
                          )
                        "
                        @delete="
                          removeOrderFromShoppingCart(
                            order,
                            orderIndex,
                            product.ItemId,
                            product.OrderItemId
                          )
                        "
                      />
                    </v-list-item-action>
                  </template>
                </v-list-item>

                <v-row
                  v-if="$vuetify.breakpoint.xsOnly"
                  :key="`order-${orderIndex}-product-${productIndex}-actions`"
                  class="ma-0 px-2 mb-2"
                  justify="end"
                >
                  <ShoppingListProductActions
                    :product="product"
                    :totalPrice="getProductTotalPrice(product)"
                    :quantity="getDisplayQuantity(product, product.Quantity)"
                    :isWeighted="product.ProductType === 'Weighted'"
                    :unit="getDisplayUnit(product)"
                    :decreaseBtnDisabled="isDecreaseBtnDisabled(product)"
                    :increaseBtnDisabled="isIncreaseBtnDisabled(product)"
                    @decrease="
                      onAddOrSubtractsProduct(
                        'subtracts',
                        product,
                        order,
                        orderIndex
                      )
                    "
                    @increase="
                      onAddOrSubtractsProduct('add', product, order, orderIndex)
                    "
                    @delete="
                      removeOrderFromShoppingCart(
                        order,
                        orderIndex,
                        product.ItemId,
                        product.OrderItemId
                      )
                    "
                  />
                </v-row>

                <v-divider
                  v-if="productIndex < order.Products.length - 1"
                  :key="`order-${orderIndex}-product-${productIndex}-divider`"
                  class="mx-3"
                />
              </template>
            </template>
          </v-card>

        </v-list>
      </v-col>
      <p v-else class="px-8 pt-5">{{ $translate('NO_PRODUCTS') }}</p>
      <template v-if="growthVitamins != null && growthVitamins.length > 0">
        <v-divider light></v-divider>
        <v-col
          v-for="(growthVitamin, gvIndex) in growthVitamins"
          :key="gvIndex"
          class="px-3 py-1"
        >
          <v-card
            @click="activateGrowthDialog(growthVitamin)"
            class="primary-font-color"
            color="primary"
            flat
          >
            <v-row class="ma-0" align="center">
              <v-avatar size="32" tile class="mx-3">
                <v-icon color="white">{{
                  getGrowthVitaminIcon(growthVitamin)
                }}</v-icon>
              </v-avatar>
              <v-col class="px-3 py-1">
                <div class="text-subtitle-2">{{ growthVitamin.Name }}</div>
                <div class="text-caption">
                  {{ getGrowthVitaminInfo(growthVitamin) }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </template>
      <section v-if="orders.length !== 0">
        <v-divider light />
        <v-row justify="end" class="ma-0">
          <v-col cols="12" md="8" class="py-2">
            <v-row v-if="isProfUser" justify="space-between" class="ma-0">
              <h5>{{ $translate('SUBTOTAL') }}</h5>
              <h5>{{ formatter.format(subtotalPrice) }}</h5>
            </v-row>
            <v-row
              v-if="getTotalDiscount < 0"
              justify="space-between"
              class="ma-0"
            >
              <h5>{{ $translate('DISCOUNT') }}</h5>
              <h5 class="red--text">
                {{ formatter.format(getTotalDiscount) }}
              </h5>
            </v-row>
            <v-row v-if="getTotalDepositValue > 0" justify="space-between" class="ma-0">
              <h5>{{ $translate('DEPOSIT_VALUE') }}</h5>
              <h5>{{ formatter.format(getTotalDepositValue) }}</h5>
            </v-row>
            <v-row v-if="isProfUser" justify="space-between" class="ma-0">
              <h5>{{ $translate('VAT') }}</h5>
              <h5>{{ formatter.format(getTotalVatPrice) }}</h5>
            </v-row>
            <v-row justify="space-between" class="ma-0">
              <h3>{{ $translate('TOTAL') }}</h3>
              <h3>{{ formatter.format(getTotalPrice) }}</h3>
            </v-row>
          </v-col>
        </v-row>
      </section>
      <v-divider light />
      <v-row class="ma-0 pa-3" justify="center">
        <v-btn
          depressed
          block
          color="primary"
          class="text-capitalize primary-font-color"
          @click="orderShoppingCart"
          :disabled="orders.length == 0"
        >
          {{ $translate('ORDER_NOW') }}
        </v-btn>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapGetters, mapState } from 'vuex';
import doRequest from '@/api/dssRequest';
import { cloneDeep } from 'lodash';
import ShoppingListProductActions from '@/components/shoppingLists/ShoppingListProductActions';
import utility from '@/shared/utility';
import ShoppingCartObj from '@/objects/ShoppingCart';
import ProductAvailabilityInfo from '@/components/event/eventDetails/productOrderComponents/ProductAvailabilityInfo';
import {
  quantityDecreasable,
  quantityIncreasable,
  getDisplayQuantity,
  getDisplayUnit,
} from '@/objects/Product';

export default {
  name: 'ShoppingCart',
  components: {
    ShoppingListProductActions,
    ProductAvailabilityInfo,
  },
  props: {
    isTransparent: Boolean,
  },
  data() {
    return {
      showMenu: false,
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
      order: {},
      allOrders: [],
      shoppingCart: [],
      interval: {},
      timer: 0,
    };
  },
  computed: {
    ...mapState('shoppingCart', {
      orders: (state) => state.orders,
    }),
    ...mapGetters({
      eventDetails: 'shoppingCart/eventDetails',
      GVTimer: 'getGVTimer',
      isProfUser: 'isProfUser',
    }),
    getQuantity() {
      let quantity = 0;
      this.shoppingCart.forEach((shoppingCartItem) => {
        if (shoppingCartItem.ShoppingCartType === 'Ticket') {
          // tickets
          if (shoppingCartItem.PriceCategories.length > 0) {
            shoppingCartItem.PriceCategories.forEach((ticket) => {
              if (ticket.Quantity > 0) {
                quantity += Number(ticket.Quantity);
              }
            });
          } else {
            quantity += 1;
          }
        } else if (
          shoppingCartItem.ShoppingCartType === 'Rental' ||
          shoppingCartItem.ShoppingCartType === 'Product'
        ) {
          // Products and Rentals
          shoppingCartItem.Products.forEach((product) => {
            if (product.ProductType !== 'Weighted') {
              quantity += Number(product.Quantity);
            } else {
              quantity += 1;
            }
          });
        } else {
          quantity += 1;
        }
      });
      return quantity;
    },
    getTotalDiscount() {
      return ShoppingCartObj.getTotalDiscount(this.allOrders);
    },
    getTotalPrice() {
      let orderTotalPrice = 0;
      this.allOrders.forEach((order) => {
        orderTotalPrice += order.OrderTotalPrice;
      });
      return orderTotalPrice;
    },
    getTotalVatPrice() {
      let totalVatPrice = 0;
      this.allOrders.forEach((order) => {
        totalVatPrice += order.OrderTotalPriceVat;
      });
      return totalVatPrice;
    },
    subtotalPrice() {
      return ShoppingCartObj.getSubtotalPrice(this.allOrders);
    },
    growthVitamins() {
      return this.$store.getters['getGrowthVitamins'];
    },
    getTotalDepositValue() {
      return ShoppingCartObj.getDepositValue(this.allOrders);
    }
  },
  watch: {
    orders() {
      this.initOrders();
      clearInterval(this.interval);

      if (this.orders.length > 0) {
        // set interval on 20 minutes
        this.checkReservationExpired();
        this.interval = setInterval(this.checkReservationExpired, 1200000);
      }

      // Orders changed, reload growth vitamins to update discounts and total price
      this.getAwardedGrowthVitaminCards();
    },
  },
  created() {
    window.EventBus.listen(
      'triggerNavigationDrawer',
      this.triggerNavigationDrawer
    );
  },
  beforeDestroy() {
    window.EventBus.removeListener(
      'triggerNavigationDrawer',
      this.triggerNavigationDrawer
    );
  },
  mounted() {
    this.initOrders();
    this.checkReservationExpired();
  },
  methods: {
    getDisplayQuantity,
    getDisplayUnit,
    initOrders() {
      this.shoppingCart = [];
      if (this.orders != null) {
        this.shoppingCart = cloneDeep(this.orders);
      }
    },
    activateGrowthDialog(growthVitamin) {
      window.EventBus.fire('activateGrowthDialog', growthVitamin);
    },
    getAwardedGrowthVitaminCards() {
      // variable to add orders to payload
      const allEventsForOrder = {};
      // loop through ticket/rental orders and set them in the variable
      this.shoppingCart.forEach((orderItem) => {
        // to create index in array with that EventId
        if (allEventsForOrder[orderItem.EventId] == null) {
          allEventsForOrder[orderItem.EventId] = [];
        }
        // add the items to that index
        allEventsForOrder[orderItem.EventId].push(orderItem.OrderId);
      });

      const payload = {
        Reservations: allEventsForOrder || {},
      };

      const object = this.$store.getters['auth/userObjectId'];

      doRequest(
        (response) => {
          let growthVitaminCards = [];

          if (response.data.GrowthVitaminCards != null) {
            growthVitaminCards = [...response.data.GrowthVitaminCards];
          }

          this.$store.commit('setGrowthVitamins', growthVitaminCards);

          // set the updated orders in the orders store variable
          this.allOrders = response.data.Orders;
        },
        () => {},
        'getAwardedGrowthVitaminCards',
        object,
        payload
      );
    },
    EmptyShoppingCart() {
      this.shoppingCart.forEach((order) => {
        const payload = {
          OrderId: order.OrderId,
          EventId: order.EventId,
        };

        const object = this.$store.getters['auth/userName']
          ? this.$store.getters['auth/userName']
          : this.$store.getters['auth/tmpUserId'];

        doRequest(
          () => {
            this.$store.commit('shoppingCart/setOrders', []);
            this.onShoppingCartEmptied();
          },
          () => {
            // Remove order locally even if error happens
            this.$store.commit('shoppingCart/setOrders', []);
            this.onShoppingCartEmptied();
          },
          'cancelReservation',
          object,
          payload
        );
      });
    },
    removeOrderFromShoppingCart(
      order,
      orderIndex,
      itemId = '',
      orderItemId = ''
    ) {
      const orderData = {
        orderIndex,
        itemId,
        orderItemId,
      };
      this.$store.commit('shoppingCart/removeOrder', orderData);
    },
    checkReservationExpired() {
      const deleteOrders = [];

      this.orders.forEach((order, index) => {
        if (this.getTimeDifference(order.Date) > 20) {
          deleteOrders.push(index);
        }
      });

      deleteOrders.forEach((deleteIndex) => {
        this.orders.splice(deleteIndex, 1);
      });
    },
    getTimeDifference(date) {
      let diff = (new Date().getTime() - new Date(date).getTime()) / 1000;
      diff /= 60;
      return Math.abs(Math.round(diff));
    },
    openInfoDialogFromShoppingCart(type) {
      switch (type) {
        case 'Product':
          this.shoppingInfoDialogText = this.$translate('PRODUCT_INFO_TEXT');
          this.shoppingCartInfoDialog = true;
          break;
        case 'Request':
          this.shoppingInfoDialogText = this.$translate('REQUEST_INFO_TEXT');
          this.shoppingCartInfoDialog = true;
          break;
        default:
          break;
      }
    },
    orderShoppingCart() {
      this.showMenu = false;
      console.log('show Booking screen')
      this.$router.push({
        name: 'Booking',
      }).catch(()=>{});
    },
    onAddOrSubtractsProduct(action, product, order, orderIndex) {
      // Add timeout id to the product to delay the backend request for changeProduct
      if (typeof product.timeoutId === 'number') {
        clearTimeout(product.timeoutId);
      }

      switch (action) {
        case 'add':
          if (product.ProductType === 'Weighted') {
            product.Quantity += product.StepSize;
            product.Amount = product.Quantity;
          } else {
            product.Quantity += 1;
          }
          break;
        case 'subtracts':
          if (product.ProductType === 'Weighted') {
            product.Quantity -= product.StepSize;
            product.Amount = product.Quantity;
          } else {
            product.Quantity -= 1;
          }
          break;
        default:
          break;
      }

      product.timeoutId = setTimeout(() => {
        this.addOrSubtractsProduct(product, order, orderIndex);
      }, 1 * 1000);
    },
    addOrSubtractsProduct(product, order, orderIndex) {
      product.EventId = order.EventId;

      let minQuantity = 1;
      if (product.ProductType === 'Weighted' && product.WeightedInfo != null) {
        minQuantity = product.WeightedInfo.Minimum;
      }

      if (product.Quantity >= minQuantity) {
        this.$store.commit('shoppingCart/changeProduct', product);
      } else {
        this.removeOrderFromShoppingCart(
          order,
          orderIndex,
          product.ItemId,
          product.OrderItemId
        );
      }
    },
    getGrowthVitaminExpireTimeText(growthVitamin) {
      if (
        growthVitamin.DiscountInfo.Type === 'Tip' ||
        growthVitamin.ExpiryUnixTime == null ||
        growthVitamin.ExpiryUnixTime <= 0
      ) {
        return '';
      }

      const expireTimeStr = utility.unixTimeToDateTimeString(
        growthVitamin.ExpiryUnixTime
      );
      const result = utility.sprintf(
        this.$translate('GROWTH_VITAMIN_EXPIRE_TEXT'),
        expireTimeStr
      );

      return result;
    },
    getGrowthMinimumOrderValueText(growthVitamin) {
      if (
        growthVitamin.DiscountInfo.Type === 'Tip' ||
        growthVitamin.DiscountInfo.MinimumOrderValue == null ||
        growthVitamin.DiscountInfo.MinimumOrderValue <= 0
      ) {
        return '';
      }

      const result = utility.sprintf(
        this.$translate('GROWTH_VITAMIN_MIN_VALUE_TEXT'),
        growthVitamin.DiscountInfo.MinimumOrderValue
      );

      return result;
    },
    getGrowthVitaminInfo(growthVitamin) {
      var resultText = '';

      let expireTimeText = this.getGrowthVitaminExpireTimeText(growthVitamin);
      if (expireTimeText !== '') {
        resultText = expireTimeText + '. ';
      }

      let minOrderValueText =
        this.getGrowthMinimumOrderValueText(growthVitamin);
      if (minOrderValueText !== '') {
        resultText += minOrderValueText + '.';
      }

      return resultText;
    },
    getGrowthVitaminIcon(growthVitamin) {
      switch (growthVitamin.DiscountInfo.Type) {
        case 'Fixed Discount':
        case 'Percentage Discount':
          return 'local_offer';
        case 'Free Delivery':
          return 'local_shipping';
        default:
          return 'mdi-lightbulb-on';
      }
    },
    getProductTotalPrice(product) {
      if (this.isProfUser) {
        return product.ItemTotalPrice - product.ItemTotalVatPrice;
      }

      return product.ItemTotalPrice;
    },
    getPriceCategoryPrice(priceCategory) {
      if (this.isProfUser) {
        return (
          priceCategory.PriceCategoryPrice - priceCategory.PriceCategoryVatPrice
        );
      }
      return priceCategory.PriceCategoryPrice;
    },
    getOrderTotalPrice(order) {
      if (this.isProfUser) {
        return order.OrderTotalPrice - order.OrderTotalPriceVat;
      }
      return order.OrderTotalPrice;
    },
    isDecreaseBtnDisabled(product) {
      if (product.ProductType === 'Rental') {
        return true;
      }

      return !quantityDecreasable(
        product.Product,
        product.Item,
        product.Quantity
      );
    },
    isIncreaseBtnDisabled(product) {
      if (product.ProductType === 'Rental') {
        return true;
      }

      return !quantityIncreasable(
        product.Product,
        product.Item,
        product.Quantity
      );
    },
    onShoppingCartEmptied() {
      /* Go to homepage if in the booking process,
      which ensures that user cannot press continue */
      if (this.$route.name === 'Booking') {
        this.$router.push({
          name: 'Homepage',
          params: {
            account_id: this.$store.getters.getRegion,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.scrollSection {
  max-height: calc(30vh);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
